import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentProject, SearchInput } from "types/generated";

export const SEARCH_INTENT_RESOURCES: TypedDocumentNode<
  { intentProject: Pick<IntentProject, "id" | "searchIntentResources"> },
  { intentProjectId: string; input: SearchInput }
> = gql`
  query SearchIntentResources($intentProjectId: ID!, $input: SearchInput!) {
    intentProject(id: $intentProjectId) {
      id
      searchIntentResources(input: $input) {
        edges {
          cursor
          node {
            address
            changedBy
            intentProjectID
            name
            operation
            provider
            resourceID
            resourceType
            state
            hcl
          }
        }
        pageInfo {
          hasNextPage
          endCursor
          startCursor
        }
      }
    }
  }
`;
